import {
  LandscapeImageProperties,
  PortraitImageProperties,
  ResponsiveImageProperties,
} from '../../../display/ResponsiveImage/types'

type LandscapePhoto = {
  image: LandscapeImageProperties
}

type PortraitPhoto = {
  image: PortraitImageProperties
}

type Photo = {
  image: ResponsiveImageProperties
}

export const getDefaultImageVersion = (photo: Photo) => {
  const image = photo?.image

  if ('w400' in image) {
    return image.w400
  }

  return image?.medium
}

export const isPortrait = (
  photo: LandscapePhoto | PortraitPhoto,
): photo is PortraitPhoto => {
  return (photo as PortraitPhoto)?.image?.w400 != null
}

export const isLandscape = (
  photo: LandscapePhoto | PortraitPhoto,
): photo is LandscapePhoto => {
  return (photo as LandscapePhoto)?.image?.medium != null
}
